// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-run-model-content>div:not(first-child){margin-top:10px}.cvat-run-model-content-remove-mapping-icon{color:#ff4136}.cvat-run-model-label-attribute-block{padding-left:32px}.detector-runner-clean-previous-annotations-wrapper span,.detector-runner-convert-masks-to-polygons-wrapper span{margin-left:8px}", ""]);
// Exports
module.exports = exports;
